export default String.raw`
<g id="Banner pojedynczy//slider">
    <rect width="360" height="1077" transform="translate(0 -160)" class="bgColor"/>
    <g id="Przewijalny baner">
        <g id="Frame 221">
            <image clip-path="inset(0% round 12px)" preserveAspectRatio="xMidYMid slice" x="16" y="24" width="328" height="200" href="./img/previewElements/mainBanner-new.png"/>
            <rect width="330" height="202" rx="12" x="15" y="23" class="bannerTextFieldColor"/>
            <g id="Frame 226">
                <text class="bannerFontColor" xml:space="preserve" style="white-space: pre" font-size="18" font-weight="600" letter-spacing="0px"><tspan x="32" y="78.5455">TRANSLATION_Prv_MainBannerA_TextA</tspan></text>
                <text class="bannerSecondaryFontColor" xml:space="preserve" style="white-space: pre" font-size="14" font-weight="500" letter-spacing="0px"><tspan x="32" y="107.091">TRANSLATION_Prv_SeeForYourself_PartA</tspan><tspan x="32" y="127.091">TRANSLATION_Prv_SeeForYourself_PartB</tspan></text>
            </g>
            <g id="Primary button">
                <rect x="32" y="148" width="296" height="40" rx="5" class="bannerBtnBgColor"/>
                <text id="Button" class="bannerBtnFontColor" xml:space="preserve" style="white-space: pre" font-size="14" font-weight="600" letter-spacing="0px"><tspan x="154.775" y="173.091">TRANSLATION_Prv_Look</tspan></text>
            </g>
        </g>
        <g id="Indicators">
            <g id="Arrow/indicator">
                <rect id="Rectangle 167" x="101" y="232" width="32" height="4" rx="1" class="lighterColor"/>
            </g>
            <g id="Arrow/indicator_2">
                <rect id="Rectangle 167_2" x="143" y="232" width="32" height="4" rx="1" class="secondaryColor"/>
            </g>
            <g id="Arrow/indicator_3">
                <rect id="Rectangle 167_3" x="185" y="232" width="32" height="4" rx="1" class="lighterColor"/>
            </g>
            <g id="Arrow/indicator_4">
                <rect id="Rectangle 167_4" x="227" y="232" width="32" height="4" rx="1" class="lighterColor"/>
            </g>
        </g>
    </g>
</g>
`;